<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-magnify</v-icon>
          <v-toolbar-title>Query Vehicle Registration & Chassis Change</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4 lg3 xl2>
                <v-subheader class="queryLabel">{{ labels.tranDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(form.tranDate) }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 lg3 xl2>
                <v-subheader class="queryLabel">{{ labels.recType }}</v-subheader>
                <div class="queryValue">{{ form.recType }}</div>
              </v-flex>
              <v-flex xs12 sm12 md4 lg3 xl2>
                <v-subheader class="queryLabel">{{ labels.tranType }}</v-subheader>
                <div class="queryValue">{{ form.tranType }}</div>
              </v-flex>
              <v-flex xs12 sm6 md6 lg3 xl3>
                <v-subheader class="queryLabel">{{ labels.origVehRegNo }}</v-subheader>
                <div class="queryValue">{{ form.origVehRegNo }}</div>
              </v-flex>
              <v-flex xs12 sm6 md6 lg3 xl3>
                <v-subheader class="queryLabel">{{ labels.newVehRegNo }}</v-subheader>
                <div class="queryValue">{{ form.newVehRegNo }}</div>
              </v-flex>
              <v-flex xs12 sm6 md6 lg3 xl3>
                <v-subheader class="queryLabel">{{ labels.origChasNo }}</v-subheader>
                <div class="queryValue">{{ form.origChasNo }}</div>
              </v-flex>
              <v-flex xs12 sm6 md6 lg3 xl3>
                <v-subheader class="queryLabel">{{ labels.newChasNo }}</v-subheader>
                <div class="queryValue">{{ form.newChasNo }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
              <span>Go Back</span>
              <v-icon right dark>mdi-cancel</v-icon>
            </v-btn>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      labels: {
        origVehRegNo: 'Original Vehicle Request No.',
        origChasNo: 'Original Chassis No.',
        tranDate: 'Transaction Date',
        revision: 'Revision',
        newVehRegNo: 'New Vehicle Request No.',
        newChasNo: 'New Chassis No.',
        recType: 'Record Type',
        tranType: 'Transaction Type'
      },
      form: {
        origVehRegNo: undefined,
        origChasNo: undefined,
        tranDate: undefined,
        revision: undefined,
        newVehRegNo: undefined,
        newChasNo: undefined,
        recType: undefined,
        tranType: undefined
      },
      queryMode: false,
      submitting: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      if (this.objParam !== undefined) {
        this.form.origVehRegNo = this.objParam.origVehRegNo
        this.form.origChasNo = this.objParam.origChasNo
        this.form.tranDate = this.objParam.tranDate
        this.form.revision = this.objParam.revision
        this.form.newVehRegNo = this.objParam.newVehRegNo
        this.form.newChasNo = this.objParam.newChasNo
        this.form.recType = this.objParam.recType
        this.form.tranType = this.objParam.tranType
      }
    },
    doCancel() {
      this.$router.push({ name: 'vehChas' })
    }
  },
  computed: {
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    }
  },
  created() {
    if (this.modeParam === 'query') {
      this.queryMode = true
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
